<template>
  <div
    class="widget-wrapper"
    :style="{
      color: isReady ? 'white' : 'transparent',
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
    }"
  >
    <h1 ref="title">
      {{ title }}
    </h1>
    <p ref="description">
      {{ description }}
    </p>
  </div>
</template>

<script>
import { getHeightRatioParentToChild } from '../../../../../helpers/utils';

export default {
  name: 'TextWidget',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      defaultTitleFontSize: '5.18518519vh',
      defaultBodyFontSize: '3.88888889vh',
      isReady: true
    };
  },
  watch: {
    title() {
      this.recalculateFontSize();
    },
    description() {
      this.recalculateFontSize();
    }
  },
  mounted() {
    this.fitFontSize();
  },
  methods: {
    resetFontSizeToDefault() {
      this.$refs['title'].style.fontSize = this.defaultTitleFontSize;
      this.$refs['description'].style.fontSize = this.defaultBodyFontSize;
    },
    recalculateFontSize() {
      this.resetFontSizeToDefault();
      this.fitFontSize();
    },
    fitFontSize() {
      this.$nextTick(() => {
        let ratio;

        while ((ratio = getHeightRatioParentToChild(this.$el)) < 1) {
          this.fit(ratio);
        }
      });
    },
    fit(ratio) {
      const titleFontSize = parseInt(getComputedStyle(this.$refs['title']).getPropertyValue('font-size'));
      const bodyFontSize = parseInt(getComputedStyle(this.$refs['description']).getPropertyValue('font-size'));

      if (ratio < 1) {
        this.$refs['title'].style.fontSize = (titleFontSize - 1) + 'px';
        this.$refs['description'].style.fontSize = (bodyFontSize - 1) + 'px';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 1.5625vw;
  color: white;
  overflow: hidden;
  min-height: 100%;
  width: 100%;
}

h1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

p {
  margin-top: 0.625vw;
  line-height: 140%;
}
</style>
